export const reportContentButtonContainerCss = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
  marginBottom: "32px",
};

export const reportContentButtonCss = {
  padding: "8px",
};
